//INVOICE
export const INVOICE_CREATE = "INVOICE_CREATE";
export const INVOICE_DRAFT_CREATE = "INVOICE_DRAFT_CREATE";
export const INVOICE_EDIT = "INVOICE_EDIT";
export const REPEAT_ORDER = "REPEAT_ORDER";
export const INVOICE_NUMBER = "INVOICE_NUMBER";
export const INVOICE_TABLE = "INVOICE_TABLE";
export const RETURN_BILL_TABLE = "RETURN_BILL_TABLE";
export const RETURN_BILL_VIEW = "RETURN_BILL_VIEW";
export const RETURN_BILL_ADD = "RETURN_BILL_ADD";
export const RETURN_BILL_UPDATE = "RETURN_BILL_UPDATE";
export const RETURN_BILL_ITEMS_GET = "RETURN_BILL_ITEMS_GET";
export const INVOICE_VIEW = "INVOICE_VIEW";
export const INVOICE_PRODUCT_DETAILS = "INVOICE_PRODUCT_DETAILS";
export const INVOICE_DISCOUNT = "INVOICE_DISCOUNT";
export const INVOICE_DISCOUNT_UPDATE = "INVOICE_DISCOUNT_UPDATE";
export const INVOICE_PAST = "INVOICE_PAST";
export const PAST_BILLS_FAMILY_MEMBERS = "PAST_BILLS_FAMILY_MEMBERS";
export const SALES_ITEMS_BY_SOT_ID = "SALES_ITEMS_BY_SOT_ID";
export const TOP_BILLS = "TOP_BILLS";
export const INVOICE_DELETE = "INVOICE_DELETE";
export const INVOICE_ALTERNATIVE = "INVOICE_ALTERNATIVE";
export const INVOICE_ROW = "INVOICE_ROW";
export const INVOICE_CLEAR = "INVOICE_CLEAR";
export const FETCH_BILL_NUMBER = "FETCH_BILL_NUMBER";
export const STORE_DETAILS = "STORE_DETAILS";
export const INVOICE_SCANNED_ITEM = "INVOICE_SCANNED_ITEM";
export const PROFIT_REPORT = "PROFIT_REPORT";
export const VENDOR_MASTER = "VENDOR_MASTER";
export const STOCK_LEDGER_BATCH = "STOCK_LEDGER_BATCH";
export const VENDOR_PAYABLE = "VENDOR_PAYABLE";
export const DAY_WISE = "DAY_WISE";
//CUSTOMER
export const CUSTOMER_CREATE = "CUSTOMER_CREATE";
export const CUSTOMER_VIEW = "CUSTOMER_VIEW";
export const CUSTOMER_DELETE = "CUSTOMER_DELETE";
export const CUSTOMER_EDIT = "CUSTOMER_EDIT";
export const CUSTOMER_TABLE = "CUSTOMER_TABLE";
//ALERT
export const ALERT_CREATE = "ALERT_CREATE";
export const ALERT_VIEW = "ALERT_VIEW";
export const ALERT_DELETE = "ALERT_DELETE";
export const ALERT_EDIT = "ALERT_EDIT";
export const ALERT_TABLE = "ALERT_TABLE";
export const ALERT_STATUS = "ALERT_STATUS";

//DOCTOR
export const DOCTOR_CREATE = "DOCTOR_CREATE";
export const DOCTOR_VIEW = "DOCTOR_VIEW";
export const DOCTOR_DELETE = "DOCTOR_DELETE";
export const DOCTOR_EDIT = "DOCTOR_EDIT";
export const DOCTOR_TABLE = "DOCTOR_TABLE";

//STOCK AUDIT
export const STOCK_AUDIT_CREATE = "STOCK_AUDIT_CREATE";
export const STOCK_AUDIT_VIEW = "STOCK_AUDIT_VIEW";
export const STOCK_AUDIT_UPLOAD_CSV = "STOCK_AUDIT_UPLOAD_CSV";
export const STOCK_AUDIT_EDIT = "STOCK_AUDIT_EDIT";
export const STOCK_AUDIT_TABLE = "STOCK_AUDIT_TABLE";
export const STOCK_AUDIT_LOAD_FILTERS = "STOCK_AUDIT_LOAD_FILTERS";
export const STOCK_AUDIT_DELETE = "STOCK_AUDIT_DELETE";

//USERS
export const USER_CREATE = "USER_CREATE";
export const USER_MOD_CREATE = "USER_MOD_CREATE";
export const USER_VIEW = "USER_VIEW";
export const USER_DELETE = "USER_DELETE";
export const USER_EDIT = "USER_EDIT";
export const USER_TABLE = "USER_TABLE";
export const USER_PERMISSIONS = "USER_PERMISSIONS";
export const USER_MOD_PERMISSIONS = "USER_MOD_PERMISSIONS";
export const UPDATE_PERMISSIONS = "UPDATE_PERMISSIONS";

//GENERAL

export const GET_ADDRSS = "GET_ADDRSS";
export const PRODUCT_LIST = "PRODUCT_LIST";
export const PRODUCT_DETAILS = "PRODUCT_DETAILS";
export const PRODUCT_BATCH_DETAILS = "PRODUCT_BATCH_DETAILS";
export const PHONE_LIST = "PHONE_LIST";
export const STATE_LIST = "STATE_LIST";
export const STORE_STATE_LIST = "STORE_STATE_LIST";
export const STORE_DISTRICT_LIST = "STORE_DISTRICT_LIST";
export const STORE_SEARCH = "STORE_SEARCH";
export const STORE_CITY_LIST = "STORE_CITY_LIST";
export const STORE_ITEM = "STORE_ITEM";
export const STORE_ITEM_PARAMED = "STORE_ITEM_PARAMED";
export const DOCTOR_LIST = "DOCTOR_LIST";
export const STORE_ID = "STORE_ID";
export const PAYMENT_METHODS_LIST = "PAYMENT_METHODS_LIST";
export const TABLE_ALERT = "TABLE_ALERT";
export const ALL_USERS_LIST = "ALL_USERS_LIST";
export const COLUMN_ALERT = "COLUMN_ALERT";
export const CATEGORY_LIST = "CATEGORY_LIST";
export const UOM_LIST = "UOM_LIST";
export const PRICE_LIST = "PRICE_LIST";
export const ITEM_GROUP_LIST = "ITEM_GROUP_LIST";
export const ITEM_TYPE_DROP_DOWN = "ITEM_TYPE_DROP_DOWN";
export const TAX_CAT_LIST = "TAX_CAT_LIST";
export const INTER_TAX_CAT_LIST = "INTER_TAX_CAT_LIST";
export const MANUFACTURERS_LIST = "MANUFACTURERS_LIST";
export const DEPARTMENT_LIST = "DEPARTMENT_LIST";
export const SHIPPING_TYPE_LIST = "SHIPPING_TYPE_LIST";
export const SECTOR_LIST = "SECTOR_LIST";
export const SCH_LIST = "SCH_LIST";
export const VENDOR_LIST = "VENDOR_LIST";
export const VALUATION_LIST = "VALUATION_LIST";
export const UOM_GROUP_LIST = "UOM_GROUP_LIST";
export const UOM_GROUP_FIND_ONE = "UOM_GROUP_FIND_ONE";
export const IMAGE_UPLOAD = "IMAGE_UPLOAD";
export const ADMIN_ROLES = "ADMIN_ROLES";
export const ADMIN_ROLES_MOD = "ADMIN_ROLES_MOD";
export const DEPARTMENR_LIST = "DEPARTMENR_LIST";
export const ROLES_LIST = "ROLES_LIST";
export const ATTACHED_ROLES_DEPARTMENT_LIST = "ATTACHED_ROLES_DEPARTMENT_LIST";
export const DOC_LIST = "DOC_LIST";
export const USERS_LIST = "USERS_LIST";
//ADMIN
export const CUSTOMER_TYPE_LIST = "CUSTOMER_TYPE_LIST";
export const ACQ_SRC_LIST = "ACQ_SRC_LIST";
export const BUISNESS_TYPE_LIST = "BUISNESS_TYPE_LIST";
export const BANK_NAME_LIST = "BANK_NAME_LIST";
export const DIS_CUS_LIST = "DIS_CUS_LIST";
export const DIS_CUS_GROUP_LIST = "DIS_CUS_GROUP_LIST";
export const DIS_CUS_CAT_LIST = "DIS_CUS_CAT_LIST";
export const DIS_CUS_TYPE_LIST = "DIS_CUS_TYPE_LIST";
export const CUSTOMER_LIST = "CUSTOMER_LIST";
export const PINCODE_LIST = "PINCODE_LIST";
export const GST_SEARCH_TAXPAYER = "GST_SEARCH_TAXPAYER";
export const MANUFACTURER_FUZZY_SEARCH = "MANUFACTURER_FUZZY_SEARCH";
export const BIN_LOCATION_LIST = "BIN_LOCATION_LIST";
export const DEFAULT_BIN_LOCATION = "DEFAULT_BIN_LOCATION";
export const SEARCH_BIN_LOCATION = "SEARCH_BIN_LOCATION";
export const WARE_HOUSE_LIST = "WARE_HOUSE_LIST";
export const WARE_HOUSE_LIST_NEW = "WARE_HOUSE_LIST_NEW";

export const TRANSACTION_SHARE = "TRANSACTION_SHARE";
export const TRANSACTION_PRINT = "TRANSACTION_PRINT";
export const STORE_LIST = "STORE_LIST";
export const SAVED_REPORTS = "SAVED_REPORTS";
export const ADD_TAGS = "ADD_TAGS";
export const GET_TAGS = "GET_TAGS";
export const SAVED_DATA_REPORTS = "SAVED_DATA_REPORTS";
export const FAV_ITEMS = "FAV_ITEMS";
export const SET_FAV_ITEMS = "SET_FAV_ITEMS";
//PRODUCT
export const PRODUCT_CREATE = "PRODUCT_CREATE";
export const PRODUCT_CREATE_FROM_BILLING = "PRODUCT_CREATE_FROM_BILLING";
export const PRODUCT_PURCHASING_CREATE = "PRODUCT_PURCHASING_CREATE";
export const PRODUCT_SALES_CREATE = "PRODUCT_SALES_CREATE";
export const PRODUCT_INVENTORY_CREATE = "PRODUCT_INVENTORY_CREATE";
export const PRODUCT_PLANNING_CREATE = "PRODUCT_PLANNING_CREATE";
export const PRODUCT_DIS_CREATE = "PRODUCT_DIS_CREATE";
export const PRODUCT_RESTRICTIONS_CREATE = "PRODUCT_RESTRICTIONS_CREATE";
export const PRODUCT_REMARKS_CREATE = "PRODUCT_REMARKS_CREATE";
export const PRODUCT_PACKING_CREATE = "PRODUCT_PACKING_CREATE";

//REGIONAL RESTRICTIONS
export const REGIONAL_RESTRICTION_LIST = "REGIONAL_RESTRICTION_LIST";
export const REGIONAL_RESTRICTION_STORE_LIST =
  "REGIONAL_RESTRICTION_STORE_LIST";
export const REGIONAL_RESTRICTION_ITEMS_LIST =
  "REGIONAL_RESTRICTION_ITEMS_LIST";
export const REGIONAL_RESTRICTION_ADD = "REGIONAL_RESTRICTION_ADD";
export const REGIONAL_RESTRICTION_CATEGORIES =
  "REGIONAL_RESTRICTION_CATEGORIES";
export const REGIONAL_RESTRICTION_TYPES = "REGIONAL_RESTRICTION_TYPES";
export const REGIONAL_RESTRICTION_GROUPS = "REGIONAL_RESTRICTION_GROUPS";
export const REGIONAL_RESTRICTION_MANUFACTURERS =
  "REGIONAL_RESTRICTION_MANUFACTURERS";
export const REGIONAL_RESTRICTION_ITEMS_BY_STORE =
  "REGIONAL_RESTRICTION_ITEMS_BY_STORE";
export const REGIONAL_RESTRICTION_BY_ITEM_ID =
  "REGIONAL_RESTRICTION_BY_ITEM_ID";
export const REGIONAL_RESTRICTION_ITEM_LIST = "REGIONAL_RESTRICTION_ITEM_LIST";
export const PRODUCT_TABLE = "PRODUCT_TABLE";
export const PRODUCT_VIEW = "PRODUCT_VIEW";
export const PRODUCT_DELETE = "PRODUCT_DELETE";
export const PRODUCT_EDIT = "PRODUCT_EDIT";
export const PRODUCT_BARCODE = "PRODUCT_BARCODE";
export const PRODUCT_BARCODES = "PRODUCT_BARCODES";
export const PRODUCT_GENERATE_ITEMCODE = "PRODUCT_GENERATE_ITEMCODE";
export const PRODUCT_VERIFY_ITEMCODE = "PRODUCT_VERIFY_ITEMCODE";
export const PRODUCT_IMPORT_CSV = "PRODUCT_IMPORT_CSV";
export const FETCH_MDM_ITEM = "FETCH_MDM_ITEM";
export const ADD_MOLECULE = "ADD_MOLECULE";
export const DELETE_MOLECULE = "DELETE_MOLECULE";

//PRODUCT
export const INVENTORY_CREATE = "INVENTORY_CREATE";
export const BINLOCATION_ADD = "BINLOCATION_ADD";
export const WAREHOUSE_LIST = "WAREHOUSE_LIST";

//WAREHOUSE
export const WAREHOUSE_GET_ID = "WAREHOUSE_GET_ID";
export const WAREHOUSE_LIST_WITH_CAPACITY = "WAREHOUSE_LIST_WITH_CAPACITY";
export const WAREHOUSE_BIN_LIST = "WAREHOUSE_BIN_LIST";
export const WAREHOUSE_BIN_GENERATE = "WAREHOUSE_BIN_GENERATE";
export const WAREHOUSE_BIN_ADD = "WAREHOUSE_BIN_ADD";
export const WAREHOUSE_BIN_UPDATE = "WAREHOUSE_BIN_UPDATE";
export const WAREHOUSE_BIN_DELETE = "WAREHOUSE_BIN_DELETE";
export const WAREHOUSE_BIN_DEFAULT_ITEMS_ADD =
  "WAREHOUSE_BIN_DEFAULT_ITEMS_ADD";
export const WAREHOUSE_BIN_DEFAULT_ITEMS_LIST =
  "WAREHOUSE_BIN_DEFAULT_ITEMS_LIST";
export const WAREHOUSE_BIN_SET_DEFAULT = "WAREHOUSE_BIN_SET_DEFAULT";
export const WAREHOUSE_BIN_ITEMS_LIST = "WAREHOUSE_BIN_ITEMS_LIST";
export const WAREHOUSE_EXPIRED_ITEMS_LIST = "WAREHOUSE_EXPIRED_ITEMS_LIST";

//STORE INFORMATION

export const DELETE_ITEM_ACTION = "DELETE_ITEM_ACTION";
export const STORE_ADDRESS_CREATE = "STORE_ADDRESS_CREATE";
export const STORE_PERSONAL_CREATE = "STORE_PERSONAL_CREATE";
export const STORE_FIRM_CREATE = "STORE_FIRM_CREATE";
export const STORE_PARTNER_CREATE = "STORE_PARTNER_CREATE";
export const STORE_AGREEMENT_CREATE = "STORE_AGREEMENT_CREATE";
export const STORE_PAYMENT_CREATE = "STORE_PAYMENT_CREATE";
export const STORE_DRUG_CREATE = "STORE_DRUG_CREATE";
export const STORE_LOI_CREATE = "STORE_LOI_CREATE";
export const FOFO_FIRM_TYPES_GET = "FOFO_FIRM_TYPES_GET";
export const STORE_ADDRESS_UPDATE = "STORE_ADDRESS_UPDATE";
export const STORE_TABLE = "STORE_TABLE";
export const STORE_VIEW = "STORE_VIEW";

//AUTH
export const STORE_LOGIN = "STORE_LOGIN";
export const STORE_FORGOT_PASSWORD = "STORE_FORGOT_PASSWORD";
export const STORE_RESET_PASSWORD = "STORE_RESET_PASSWORD";

//ADMIN_CUSTOMER
export const ADMIN_CUSTOMER_CREATE = "ADMIN_CUSTOMER_CREATE";
export const ADMIN_CUSTOMER_EDIT = "ADMIN_CUSTOMER_EDIT";
export const ADMIN_CUSTOMER_CONTACT_PERSON = "ADMIN_CUSTOMER_CONTACT_PERSON";
export const ADMIN_CUSTOMER_BNK_DTLS = "ADMIN_CUSTOMER_BNK_DTLS";
export const ADMIN_CUSTOMER_PAYMENT_TERMS = "ADMIN_CUSTOMER_PAYMENT_TERMS";
export const ADMIN_CUSTOMER_ACCOUNTING = "ADMIN_CUSTOMER_ACCOUNTING";
export const ADMIN_CUSTOMER_ADDRESS = "ADMIN_CUSTOMER_ADDRESS";

export const ADMIN_CUSTOMER_TABLE = "ADMIN_CUSTOMER_TABLE";
export const ADMIN_CUSTOMER_DELETE = "ADMIN_CUSTOMER_DELETE";
export const ADMIN_CUSTOMER_VIEW = "ADMIN_CUSTOMER_VIEW";
export const ADMIN_CUSTOMER_UPDATE_CONTACT_PERSON =
  "ADMIN_CUSTOMER_UPDATE_CONTACT_PERSON";
export const ADMIN_CUSTOMER_UPDATE_BNK_DTLS = "ADMIN_CUSTOMER_UPDATE_BNK_DTLS";
export const ADMIN_CUSTOMER_UPDATE_PAYMENT_TERMS =
  "ADMIN_CUSTOMER_UPDATE_PAYMENT_TERMS";
export const ADMIN_CUSTOMER_UPDATE_ACCOUNTING =
  "ADMIN_CUSTOMER_UPDATE_ACCOUNTING";
export const ADMIN_CUSTOMER_UPDATE_ADDRESS = "ADMIN_CUSTOMER_UPDATE_ADDRESS";
//CUSTOMER DROP DOWNS
export const RELATION = "RELATION";
export const INSURANCE_PROVIDER = "INSURANCE_PROVIDER";
export const GENDER = "GENDER";
export const BLOOD_GROOP = "BLOOD_GROOP";
export const ID_PROOF = "ID_PROOF";
export const PAYMENT_TERMS = "PAYMENT_TERMS";
export const GROUP_LIST = "GROUP_LIST";
export const ACQUIRED_SOURCE = "ACQUIRED_SOURCE";
export const DISCOUNT_GROUP = "DISCOUNT_GROUP";
export const UPDATE_PATIENT = "UPDATE_PATIENT";
export const UPDATE_FAMILY = "UPDATE_FAMILY";
export const UPDATE_INSURANCE = "UPDATE_INSURANCE";
export const ACCESS_TOKEN = "ACCESS_TOKEN";

//DISCOUNTS
export const PRICE_LIST_TABLE = "PRICE_LIST_TABLE";
export const PRICE_LIST_CREATE = "PRICE_LIST_CREATE";
export const PRICE_LIST_DELETE = "PRICE_LIST_DELETE";
export const PRICE_LIST_ITEMS = "PRICE_LIST_ITEMS";
export const PRICE_LIST_VIEW = "PRICE_LIST_VIEW";
export const PRICE_LIST_EDIT = "PRICE_LIST_EDIT";
export const PRICE_LIST_EDIT_BY_CSV = "PRICE_LIST_EDIT_BY_CSV";
export const PRICE_LIST_ITEM_EDIT = "PRICE_LIST_ITEM_EDIT";
export const ALL_DISCOUNT_GROUP = "ALL_DISCOUNT_GROUP";
export const DIS_ITEM_GROUP_CREATE = "DIS_ITEM_GROUP_CREATE";
export const DIS_MANUFAC_GROUP_CREATE = "DIS_MANUFAC_GROUP_CREATE";
export const DIS_ITEMS_CREATE = "DIS_ITEMS_CREATE";
export const DIS_ITEMS_FETCH = "DIS_ITEMS_FETCH";
export const PER_DIS_ITEMS_LIST = "PER_DIS_ITEMS_LIST";
export const PER_VOL_PRICE_LIST_ITEMS = "PER_VOL_PRICE_LIST_ITEMS";
export const PERIOD_VOLUME_CREATE = "PERIOD_VOLUME_CREATE";
export const PERIOD_VOLUME_ADD = "PERIOD_VOLUME_ADD";
export const PERIOD_VOLUME_GET = "PERIOD_VOLUME_GET";

// STORE EXECUTION
export const ADD_STR_INFRA_DETAILS = "ADD_STR_INFRA_DETAILS";
export const ADD_STR_BRANDING_DETAILS = "ADD_STR_BRANDING_DETAILS";
export const ADD_STR_BRAND_SFT_DETAILS = "ADD_STR_BRAND_SFT_DETAILS";
export const ADD_STR_ACCOUNT_DETAILS = "ADD_STR_ACCOUNT_DETAILS";
export const ADD_STR_DISPATCH_DETAILS = "ADD_STR_DISPATCH_DETAILS";
export const ADD_STR_OPENING_DETAILS = "ADD_STR_OPENING_DETAILS";
export const ADD_STR_FOLLOW_UP_REMARKS = "ADD_STR_FOLLOW_UP_REMARKS";
export const FOLLOW_UP_REMARKS_GET = "FOLLOW_UP_REMARKS_GET";
export const STORE_EXE_GET = "STORE_EXE_GET";
//---------------------SALES-----------------------------
//SALES ORDER
export const SALES_TAX_CAL = "SALES_TAX_CAL";
export const SALES_CREATE = "SALES_CREATE";
export const SALES_EDIT = "SALES_EDIT";
export const SALES_TABLE = "SALES_TABLE";
export const SALES_PRODUCT_LIST = "SALES_PRODUCT_LIST";
export const SALES_ORDER_ITEMS_GET = "SALES_ORDER_ITEMS_GET";
export const SALES_VIEW = "SALES_VIEW";
export const SALES_VOID = "SALES_VOID";
export const SALES_PRODUCT_DETAILS = "SALES_PRODUCT_DETAILS";
//SALES DELIVERY RECEIPT
export const SALES_DELIVERY_TABLE = "SALES_DELIVERY_TABLE";
export const SALES_DELIVERY_RECEIPT_CREATE = "SALES_DELIVERY_RECEIPT_CREATE";
export const SALES_DELIVERY_VIEW = "SALES_DELIVERY_VIEW";
export const SALES_DELIVERY_ITEMS_GET = "SALES_DELIVERY_ITEMS_GET";
export const SALES_DELIVERY_VOID = "SALES_DELIVERY_VOID";
export const SALES_DELIVERY_EDIT = "SALES_DELIVERY_EDIT";
//PICK_LIST
export const CREATE_PICKLIST = "CREATE_PICKLIST";
export const VIEW_PICKLIST = "VIEW_PICKLIST";
export const UPDATE_PICKLIST = "UPDATE_PICKLIST";
export const PICKLIST_TABLE = "PICKLIST_TABLE";
export const PICKLIST_DASHBOARD = "PICKLIST_DASHBOARD";
export const PICKLIST_ITEMS_GET = "PICKLIST_ITEMS_GET";
export const PICKLIST_VIEW_ITEMS = "PICKLIST_VIEW_ITEMS";
export const BACKEND_CONFIG_GET = "BACKEND_CONFIG_GET";
export const PICKLIST_CONFIG_SET = "PICKLIST_CONFIG_SET";
export const BARCODE_GEN_CONFIG_SET = "BARCODE_GEN_CONFIG_SET";
export const DROPLIST_CONFIG_SET = "DROPLIST_CONFIG_SET";
export const GRN_SYNC_FROM_SI_CONFIG_SET = "GRN_SYNC_FROM_SI_CONFIG_SET";
export const BACKEND_CONFIG_LOADED = "BACKEND_CONFIG_LOADED";
export const BACKEND_CONFIG_RESET = "BACKEND_CONFIG_RESET";
export const VOID_PICKLIST = "VOID_PICKLIST";
//DROP_LIST
export const CREATE_DROPLIST = "CREATE_DROPLIST";
export const VIEW_DROPLIST = "VIEW_DROPLIST";
export const UPDATE_DROPLIST = "UPDATE_DROPLIST";
export const DROPLIST_TABLE = "DROPLIST_TABLE";
export const DROPLIST_DASHBOARD = "DROPLIST_DASHBOARD";
export const DROPLIST_ITEMS_GET = "DROPLIST_ITEMS_GET";
export const DROPLIST_VIEW_ITEMS = "DROPLIST_VIEW_ITEMS";
export const VOID_DROPLIST = "VOID_DROPLIST";
//SALES INVOICE RECEIPT
export const SALES_INVOICE_TABLE = "SALES_INVOICE_TABLE";
//E-WAY BILL
export const E_WAY_BILL_TABLE = "E_WAY_BILL_TABLE";
export const E_WAY_BILL_AUTH_TOKEN = "E_WAY_BILL_AUTH_TOKEN";
export const E_WAY_BILL_INVOICE_DATA = "E_WAY_BILL_INVOICE_DATA";
export const E_WAY_BILL_CREATE = "E_WAY_BILL_CREATE";
export const E_WAY_BILL_VIEW    = "E_WAY_BILL_VIEW";
export const E_WAY_BILL_MASTERS = "E_WAY_BILL_MASTERS";
export const E_WAY_BILL_UPDATE_TRANSPORTER  = "E_WAY_BILL_UPDATE_TRANSPORTER";
export const E_WAY_BILL_CANCEL              = "E_WAY_BILL_CANCEL";
export const E_WAY_BILL_REJECT              = "E_WAY_BILL_REJECT";
//E-INVOICE
export const E_INVOICE_TABLE = "E_INVOICE_TABLE";
export const E_INVOICE_GENERATE = "E_INVOICE_GENERATE";
export const E_INVOICE_AUTH_TOKEN = "E_INVOICE_AUTH_TOKEN";
export const E_INVOICE_INVOICE_DATA = "E_INVOICE_INVOICE_DATA";
export const SALES_INVOICE_RECEIPT_CREATE = "SALES_INVOICE_RECEIPT_CREATE";
export const SALES_INVOICE_VIEW = "SALES_INVOICE_VIEW";
export const SALES_INVOICE_ITEMS_GET = "SALES_INVOICE_ITEMS_GET";
export const SALES_INVOICE_VOID = "SALES_INVOICE_VOID";
export const SALES_INVOICE_EDIT = "SALES_INVOICE_EDIT";
//SALES RETURN
export const SALES_RETURN_TABLE = "SALES_RETURN_TABLE";
export const SALES_RETURN_RECEIPT_CREATE = "SALES_RETURN_RECEIPT_CREATE";
export const SALES_RETURN_VIEW = "SALES_RETURN_VIEW";
export const SALES_RETURN_ITEMS_GET = "SALES_RETURN_ITEMS_GET";
export const SALES_RETURN_VOID = "SALES_RETURN_VOID";
export const SALES_RETURN_EDIT = "SALES_RETURN_EDIT";
//SALES CREDIT NOTE
export const SALES_CREDIT_TABLE = "SALES_CREDIT_TABLE";
export const SALES_CREDIT_RECEIPT_CREATE = "SALES_CREDIT_RECEIPT_CREATE";
export const SALES_CREDIT_VIEW = "SALES_CREDIT_VIEW";
export const SALES_CREDIT_ITEMS_GET = "SALES_CREDIT_ITEMS_GET";
export const SALES_CREDIT_VOID = "SALES_CREDIT_VOID";
export const SALES_CREDIT_EDIT = "SALES_CREDIT_EDIT";
//PAYMENT IN
export const SALES_PAYMENT_IN_CUS = "SALES_PAYMENT_IN_CUS";
export const PAYMENT_IN_TABLE = "PAYMENT_IN_TABLE";
export const GL_ACC_LIST = "GL_ACC_LIST";
export const PAYMENT_IN_CREATE = "PAYMENT_IN_CREATE";
export const PAYMENT_IN_EDIT = "PAYMENT_IN_EDIT";
export const PAYMENT_IN_VIEW = "PAYMENT_IN_VIEW";

//---------------------------PURCHASE----------------------------------------
//PURCHASE ORDER
export const PURCHASE_CREATE = "PURCHASE_CREATE";
export const PURCHASE_TABLE = "PURCHASE_TABLE";
export const PURCHASE_PRODUCT_LIST = "PURCHASE_PRODUCT_LIST";
export const PURCHASE_VIEW = "PURCHASE_VIEW";
export const PURCHASE_EDIT = "PURCHASE_EDIT";
export const PURCHASE_ITEMS_GET = "PURCHASE_ITEMS_GET";
export const PURCHASE_VOID = "PURCHASE_VOID";
export const PURCHASE_PRODUCT_DETAILS = "PURCHASE_PRODUCT_DETAILS";
export const PURCHASE_ITEM_QTY_CONVERSION = "PURCHASE_ITEM_QTY_CONVERSION";
export const PURCHASE_EXPIRY_BIN="PURCHASE_EXPIRY_BIN"
export const PURCHASE_SLOW_NON_MOVING_ITEMS="PURCHASE_SLOW_NON_MOVING_ITEMS"
export const PURCHASE_EXPIRED_ITEMS_GET="PURCHASE_EXPIRED_ITEMS_GET"
export const PURCHASE_VENDORS_FOR_ITEM_BATCH_GET="PURCHASE_VENDORS_FOR_ITEM_BATCH_GET"
export const PURCHASE_RETURN_BULK_DRAFT_CREATE="PURCHASE_RETURN_BULK_DRAFT_CREATE"

//GOODS RECEIPT
export const GOODS_ITEMS_GET = "GOODS_ITEMS_GET";
export const GOODS_TABLE = "GOODS_TABLE";
export const GOODS_RECEIPT_CREATE = "GOODS_RECEIPT_CREATE";
export const GOODS_RECEIPT_CREATE_BULK = "GOODS_RECEIPT_CREATE_BULK";
export const GOODS_RECEIPT_VIEW = "GOODS_RECEIPT_VIEW";
export const GOODS_PRINT_DETAILS_GET = "GOODS_PRINT_DETAILS_GET";
export const PURCHASE_INVOICE_PRINT_DETAILS_GET =
  "PURCHASE_INVOICE_PRINT_DETAILS_GET";
export const PRINT_LABEL_SETTINGS_SAVE = "PRINT_LABEL_SETTINGS_SAVE";
export const PRINT_LABEL_SETTINGS_GET = "PRINT_LABEL_SETTINGS_GET";
export const GOODS_RECEIPT_VOID = "GOODS_RECEIPT_VOID";
export const GOODS_RECEIPT_EDIT = "GOODS_RECEIPT_EDIT";
export const GOODS_TEMP_PRODUCTS_VERIFY = "GOODS_TEMP_PRODUCTS_VERIFY";
export const GOODS_TEM_PRODUCTS_IMPORT = "GOODS_TEM_PRODUCTS_IMPORT";
export const GOODS_USER_TEMPLATE = "GOODS_USER_TEMPLATE";
export const GOODS_CR_DB_NOTES = "GOODS_CR_DB_NOTES";
//PURCHASE INVOICE RECEIPT
export const PURCHASE_INVOICE_TABLE = "PURCHASE_INVOICE_TABLE";
export const PURCHASE_INVOICE_RECEIPT_CREATE =
  "PURCHASE_INVOICE_RECEIPT_CREATE";
export const PURCHASE_INVOICE_VIEW = "PURCHASE_INVOICE_VIEW";
export const PURCHASE_INVOICE_ITEMS_GET = "PURCHASE_INVOICE_ITEMS_GET";
export const PURCHASE_INVOICE_VOID = "PURCHASE_INVOICE_VOID";
export const PURCHASE_INVOICE_EDIT = "PURCHASE_INVOICE_EDIT";
//PURCHASE RETURN
export const PURCHASE_RETURN_TABLE = "PURCHASE_RETURN_TABLE";
export const PURCHASE_RETURN_RECEIPT_CREATE = "PURCHASE_RETURN_RECEIPT_CREATE";
export const PURCHASE_RETURN_VIEW = "PURCHASE_RETURN_VIEW";
export const PURCHASE_RETURN_ITEMS_GET = "PURCHASE_RETURN_ITEMS_GET";
export const PURCHASE_RETURN_VOID = "PURCHASE_RETURN_VOID";
export const PURCHASE_RETURN_EDIT = "PURCHASE_RETURN_EDIT";
//PURCHASE CREDIT NOTE
export const PURCHASE_CREDIT_TABLE = "PURCHASE_CREDIT_TABLE";
export const PURCHASE_CREDIT_RECEIPT_CREATE = "PURCHASE_CREDIT_RECEIPT_CREATE";
export const PURCHASE_CREDIT_VIEW = "PURCHASE_CREDIT_VIEW";
export const PURCHASE_CREDIT_ITEMS_GET = "PURCHASE_CREDIT_ITEMS_GET";
export const PURCHASE_CREDIT_VOID = "PURCHASE_CREDIT_VOID";
export const PURCHASE_CREDIT_EDIT = "PURCHASE_CREDIT_EDIT";

//PAYMENT IN
export const PURCHASE_PAYMENT_OUT_CUS = "PURCHASE_PAYMENT_OUT_CUS";
export const PAYMENT_OUT_TABLE = "PAYMENT_OUT_TABLE";
export const PAYMENT_OUT_CREATE = "PAYMENT_OUT_CREATE";
export const PAYMENT_OUT_VIEW = "PAYMENT_OUT_VIEW";
export const PAYMENT_OUT_EDIT = "PAYMENT_OUT_EDIT";

//BULK PURCHASE
export const LOADING_CSV = "LOADING_CSV";
export const LOADED_MIN_QTY_ITEMS = "LOADED_MIN_QTY_ITEMS";
export const LOADED_FAILED_MIN_QTY_ITEMS = "LOADED_FAILED_MIN_QTY_ITEMS";

export const BULK_PURCHASE_CREATE = "BULK_PURCHASE_CREATE";
export const LOAD_MIN_QTY_ITEMS = "LOAD_MIN_QTY_ITEMS";
export const UPLOAD_PO_CSV = "UPLOAD_PO_CSV";
export const PURCHASE_TAX_CAL = "PURCHASE_TAX_CAL";

//ITEM INVENTORY SETUP (BULK PO)
export const ITEM_CATEGORY_BULK_PO_LIST = "ITEM_CATEGORY_BULK_PO_LIST";
export const ITEM_CATEGORY_BULK_PO_UPDATE = "ITEM_CATEGORY_BULK_PO_UPDATE";
export const ITEM_SALES_SEARCH_BULK_PO = "ITEM_SALES_SEARCH_BULK_PO";
export const ITEM_BULK_PO_UPDATE = "ITEM_BULK_PO_UPDATE";
export const ITEM_SALES_MOLECULE_BULK_PO = "ITEM_SALES_MOLECULE_BULK_PO";

//FINANCIAL LEDGER EFFECT
export const FINANCIAL_ACCOUNT_ADD = "FINANCIAL_ACCOUNT_ADD";
export const FINANCIAL_ACCOUNT_GET = "FINANCIAL_ACCOUNT_GET";
export const FINANCIAL_ACCOUNT_DELETE = "FINANCIAL_ACCOUNT_DELETE";
export const FINANCIAL_ACCOUNT_UPDATE = "FINANCIAL_ACCOUNT_UPDATE";
export const FINANCIAL_PERIOD_SELECTION = "FINANCIAL_PERIOD_SELECTION";
export const FINANCIAL_ALL_ACC = "FINANCIAL_ALL_ACC";
export const FINANCIAL_ACC_LIST = "FINANCIAL_ACC_LIST";
export const FINANCIAL_ACC_ALLOCATION_UPDATE =
  "FINANCIAL_ACC_ALLOCATION_UPDATE";
export const JOURNAL_ENTRY_FETCH = "JOURNAL_ENTRY_FETCH";
export const JOURNAL_ENTRY_UPDATE = "JOURNAL_ENTRY_UPDATE";
export const JOURNAL_ENTRY_VIEW = "JOURNAL_ENTRY_VIEW";

//SETTINGS
export const ADD_UOM = "ADD_UOM";
export const UPDATE_UOM = "UPDATE_UOM";
export const LIST_UOM = "LIST_UOM";
export const UOM_IMPORT = "UOM_IMPORT";

export const UOM_GROUP_TABLE_LIST = "UOM_GROUP_TABLE_LIST";
export const ADD_UOM_GROUP = "ADD_UOM_GROUP";
export const UPDATE_UOM_GROUP = "UPDATE_UOM_GROUP";
export const DELETE_UOM_GROUP = "DELETE_UOM_GROUP";
export const DELETE_UOM_GROUP_ITEM = "DELETE_UOM_GROUP_ITEM";
export const UOM_DROPDOWN = "UOM_DROPDOWN";
export const UOM_DROPDOWN_NEW = "UOM_DROPDOWN_NEW";

export const UOM_GROUP_IMPORT = "UOM_GROUP_IMPORT";
export const UOM_GROUP_ITEM_IMPORT = "UOM_GROUP_ITEM_IMPORT";
export const UOM_GROUP_CALCULATION = "UOM_GROUP_CALCULATION";

export const ITEM_TYPE_LIST = "ITEM_TYPE_LIST";
export const ADD_ITEM_TYPE = "ADD_ITEM_TYPE";
export const UPDATE_ITEM_TYPE = "UPDATE_ITEM_TYPE";
export const DELETE_ITEM_TYPE = "DELETE_ITEM_TYPE";
export const ITEM_TYPE_IMPORT = "ITEM_TYPE_IMPORT";

export const ITEM_CATEGORY_LIST = "ITEM_CATEGORY_LIST";
export const ADD_ITEM_CATEGORY = "ADD_ITEM_CATEGORY";
export const UPDATE_ITEM_CATEGORY = "UPDATE_ITEM_CATEGORY";
export const DELETE_ITEM_CATEGORY = "DELETE_ITEM_CATEGORY";
export const ITEM_CATEGORY_IMPORT = "ITEM_CATEGORY_IMPORT";

export const ITEM_GROUP_TABLE_LIST = "ITEM_GROUP_TABLE_LIST";
export const ADD_ITEM_GROUP = "ADD_ITEM_GROUP";
export const UPDATE_ITEM_GROUP = "UPDATE_ITEM_GROUP";
export const DELETE_ITEM_GROUP = "DELETE_ITEM_GROUP";
export const ITEM_GROUP_IMPORT = "ITEM_GROUP_IMPORT";

export const MANUFACTURERS_TABLE_LIST = "MANUFACTURERS_TABLE_LIST";
export const ADD_MANUFACTURER = "ADD_MANUFACTURER";
export const UPDATE_MANUFACTURER = "UPDATE_MANUFACTURER";
export const DELETE_MANUFACTURER = "DELETE_MANUFACTURER";
export const MANUFACTURERS_IMPORT = "MANUFACTURERS_IMPORT";

export const TAX_TYPE_LIST = "TAX_TYPE_LIST";
export const ADD_TAX_TYPE = "ADD_TAX_TYPE";
export const UPDATE_TAX_TYPE = "UPDATE_TAX_TYPE";
export const DELETE_TAX_TYPE = "DELETE_TAX_TYPE";
export const TAX_TYPE_IMPORT = "TAX_TYPE_IMPORT";

export const TAX_COMBINATION_LIST = "TAX_COMBINATION_LIST";
export const ADD_TAX_COMBINATION = "ADD_TAX_COMBINATION";
export const UPDATE_TAX_COMBINATION = "UPDATE_TAX_COMBINATION";
export const DELETE_TAX_COMBINATION = "DELETE_TAX_COMBINATION";
export const DELETE_TAX_COMBINATION_ITEM = "DELETE_TAX_COMBINATION_ITEM";
export const TAX_TYPE_DROPDOWN = "TAX_TYPE_DROPDOWN";
export const TAX_COMBINATION_IMPORT = "TAX_COMBINATION_IMPORT";

export const SHIPPING_TYPE_TABLE__LIST = "SHIPPING_TYPE_TABLE__LIST";
export const ADD_SHIPPING_TYPE = "ADD_SHIPPING_TYPE";
export const UPDATE_SHIPPING_TYPE = "UPDATE_SHIPPING_TYPE";
export const DELETE_SHIPPING_TYPE = "DELETE_SHIPPING_TYPE";
export const SHIPPING_TYPE_IMPORT = "SHIPPING_TYPE_IMPORT";

export const DOCUMENT_NUMBERING_LIST = "DOCUMENT_NUMBERING_LIST";
export const DOCUMENT_NUMBERING_STORE_LIST = "DOCUMENT_NUMBERING_STORE_LIST";
export const DOCUMENT_NUMBERING_UPDATE = "DOCUMENT_NUMBERING_UPDATE";
export const DOCUMENT_NUMBERING_SERIES_LIST = "DOCUMENT_NUMBERING_SERIES_LIST";
export const DOCUMENT_NUMBERING_SERIES_ADD = "DOCUMENT_NUMBERING_SERIES_ADD";
export const DOCUMENT_NUMBERING_SERIES_UPDATE =
  "DOCUMENT_NUMBERING_SERIES_UPDATE";

export const CUSTOM_NUMBERING_LIST = "CUSTOM_NUMBERING_LIST";
export const CUSTOM_NUMBERING_UPDATE = "CUSTOM_NUMBERING_UPDATE";
export const CUSTOM_NUMBERING_SERIES_LIST = "CUSTOM_NUMBERING_SERIES_LIST";
export const CUSTOM_NUMBERING_SERIES_ADD = "CUSTOM_NUMBERING_SERIES_ADD";
export const CUSTOM_NUMBERING_SERIES_UPDATE = "CUSTOM_NUMBERING_SERIES_UPDATE";

export const SMTP_VIEW = "SMTP_VIEW";
export const SMTP_ADD = "SMTP_ADD";
export const SMTP_UPDATE = "SMTP_UPDATE";

export const WHATSAPP_VIEW = "WHATSAPP_VIEW";
export const WHATSAPP_ADD = "WHATSAPP_ADD";
export const WHATSAPP_UPDATE = "WHATSAPP_UPDATE";

export const SMS_VIEW = "SMS_VIEW";
export const SMS_ADD = "SMS_ADD";
export const SMS_UPDATE = "SMS_UPDATE";

export const RAZORPAY_VIEW = "RAZORPAY_VIEW";
export const RAZORPAY_ADD = "RAZORPAY_ADD";
export const RAZORPAY_UPDATE = "RAZORPAY_UPDATE";

export const STRIPE_VIEW = "STRIPE_VIEW";
export const STRIPE_ADD = "STRIPE_ADD";
export const STRIPE_UPDATE = "STRIPE_UPDATE";

export const PHONEPE_VIEW = "PHONEPE_VIEW";
export const PHONEPE_ADD = "PHONEPE_ADD";
export const PHONEPE_UPDATE = "PHONEPE_UPDATE";
export const BILLING_TYPES = "BILLING_TYPES";
export const PAYTM_VIEW = "PAYTM_VIEW";
export const PAYTM_ADD = "PAYTM_ADD";
export const PAYTM_UPDATE = "PAYTM_UPDATE";

export const PINE_LABS_VIEW = "PINE_LABS_VIEW";
export const PINE_LABS_ADD = "PINE_LABS_ADD";
export const PINE_LABS_UPDATE = "PINE_LABS_UPDATE";

export const PRINTPREFERENCE_LIST = "PRINTPREFERENCE_LIST";
export const PRINTPREFERENCE_UPDATE = "PRINTPREFERENCE_UPDATE";
export const CURRENT_PRINTPREFERENCE = "CURRENT_PRINTPREFERENCE";

export const STORE_UPDATE = "STORE_UPDATE";
export const STORE_GET = "STORE_GET";

export const MAP_ALTERNATIVE_ITEM = "MAP_ALTERNATIVE_ITEM";
export const ALTERNATIVE_ITEMS_LIST = "ALTERNATIVE_ITEMS_LIST";
export const DELETE_ALTERNATIVE_TRANSACTION = "DELETE_ALTERNATIVE_TRANSACTION";
export const ALTERNATIVE_ITEMS_IMPORT = "ALTERNATIVE_ITEMS_IMPORT";

export const ADD_CUSTOM_INVOICE = "ADD_CUSTOM_INVOICE";

//ROLES AND DEPARTMENTS
export const DEPARTMENT_SEARCH = "DEPARTMENT_SEARCH";
export const ROLE_SEARCH = "ROLE_SEARCH";
export const DEPARTMENT_CREATE = "DEPARTMENT_CREATE";
export const ROLE_CREATE = "ROLE_CREATE";
export const ROLE_DELETE = "ROLE_DELETE";
export const ROLE_UPLOAD = "ROLE_UPLOAD";
export const DEPARTMENT_UPLOAD = "DEPARTMENT_UPLOAD";
export const ATTACHED_ROLES_DEPARTMENT_CREATE =
  "ATTACHED_ROLES_DEPARTMENT_CREATE";
export const ATTACHED_ROLES_DEPARTMENT_DELETE =
  "ATTACHED_ROLES_DEPARTMENT_DELETE";
export const DEPARTMENT_DELETE = "DEPARTMENT_DELETE";
export const DEPARTMENT_EDIT = "DEPARTMENT_EDIT";
export const ROLE_EDIT = "ROLE_EDIT";

// DATA SETUP
export const DRUG_SEARCH = "DRUG_SEARCH";
export const DRUG_CREATE = "DRUG_CREATE";
export const DRUG_DELETE = "DRUG_DELETE";
export const DRUG_EDIT = "DRUG_EDIT";
export const DRUG_UPLOAD = "DRUG_UPLOAD";

export const GENERIC_SEARCH = "GENERIC_SEARCH";
export const GENERIC_CREATE = "GENERIC_CREATE";
export const GENERIC_DELETE = "GENERIC_DELETE";
export const GENERIC_EDIT = "GENERIC_EDIT";
export const GENERIC_UPLOAD = "GENERIC_UPLOAD";
export const COMPOSITION_SEARCH = "COMPOSITION_SEARCH";
export const COMPOSITION_CREATE = "COMPOSITION_CREATE";
export const COMPOSITION_DELETE = "COMPOSITION_DELETE";
export const COMPOSITION_EDIT = "COMPOSITION_EDIT";
export const COMPOSITION_UPLOAD = "COMPOSITION_UPLOAD";
export const LEAD_SEARCH = "LEAD_SEARCH";
export const LEAD_CREATE = "LEAD_CREATE";
export const LEAD_DELETE = "LEAD_DELETE";
export const LEAD_EDIT = "LEAD_EDIT";
export const LEAD_UPLOAD = "LEAD_UPLOAD";
export const PAYMENT_SEARCH = "PAYMENT_SEARCH";
export const PAYMENT_CREATE = "PAYMENT_CREATE";
export const PAYMENT_DELETE = "PAYMENT_DELETE";
export const PAYMENT_EDIT = "PAYMENT_EDIT";
export const PAYMENT_UPLOAD = "PAYMENT_UPLOAD";
export const PAYMENT_TYPE_LIST = "PAYMENT_TYPE_LIST";
export const PAYMENT_TYPE_CREATE = "PAYMENT_TYPE_CREATE";
export const PAYMENT_TYPE_UPDATE = "PAYMENT_TYPE_UPDATE";
export const PAYMENT_TYPE_DELETE = "PAYMENT_TYPE_DELETE";
export const PARTY_SEARCH = "PARTY_SEARCH";
export const PARTY_CREATE = "PARTY_CREATE";
export const PARTY_DELETE = "PARTY_DELETE";
export const PARTY_EDIT = "PARTY_EDIT";
export const PARTY_UPLOAD = "PARTY_UPLOAD";

export const PARTY_CATEGORY_SEARCH = "PARTY_CATEGORY_SEARCH";
export const PARTY_CATEGORY_CREATE = "PARTY_CATEGORY_CREATE";
export const PARTY_CATEGORY_DELETE = "PARTY_CATEGORY_DELETE";
export const PARTY_CATEGORY_EDIT = "PARTY_CATEGORY_EDIT";
export const PARTY_CATEGORY_UPLOAD = "PARTY_CATEGORY_UPLOAD";

export const PACKING_SEARCH = "PACKING_SEARCH";
export const PACKING_CREATE = "PACKING_CREATE";
export const PACKING_DELETE = "PACKING_DELETE";
export const PACKING_EDIT = "PACKING_EDIT";
export const PACKING_UPLOAD = "PACKING_UPLOAD";

export const PACKING_TYPE_SEARCH = "PACKING_TYPE_SEARCH";
export const PACKING_TYPE_CREATE = "PACKING_TYPE_CREATE";
export const PACKING_TYPE_DELETE = "PACKING_TYPE_DELETE";
export const PACKING_TYPE_EDIT = "PACKING_TYPE_EDIT";
export const PACKING_TYPE_UPLOAD = "PACKING_TYPE_UPLOAD";

export const CARTON_SEARCH = "CARTON_SEARCH";
export const CARTON_CREATE = "CARTON_CREATE";
export const CARTON_DELETE = "CARTON_DELETE";
export const CARTON_EDIT = "CARTON_EDIT";
export const CARTON_UPLOAD = "CARTON_UPLOAD";

// ================== LOCATION ==================
// COUNTRY
export const COUNTRY_SEARCH = "COUNTRY_SEARCH";
export const COUNTRY_CREATE = "COUNTRY_CREATE";
export const COUNTRY_DELETE = "COUNTRY_DELETE";
export const COUNTRY_EDIT = "COUNTRY_EDIT";
export const COUNTRY_UPLOAD = "COUNTRY_UPLOAD";

// REGION
export const REGION_SEARCH = "REGION_SEARCH";
export const REGION_CREATE = "REGION_CREATE";
export const REGION_DELETE = "REGION_DELETE";
export const REGION_EDIT = "REGION_EDIT";
export const REGION_UPLOAD = "REGION_UPLOAD";

// STATE
export const STATE_SEARCH = "STATE_SEARCH";
export const STATE_CREATE = "STATE_CREATE";
export const STATE_DELETE = "STATE_DELETE";
export const STATE_EDIT = "STATE_EDIT";
export const STATE_UPLOAD = "STATE_UPLOAD";

// DISTRICT
export const DISTRICT_SEARCH = "DISTRICT_SEARCH";
export const DISTRICT_CREATE = "DISTRICT_CREATE";
export const DISTRICT_DELETE = "DISTRICT_DELETE";
export const DISTRICT_EDIT = "DISTRICT_EDIT";
export const DISTRICT_UPLOAD = "DISTRICT_UPLOAD";

// CITY
export const CITY_SEARCH = "CITY_SEARCH";
export const CITY_CREATE = "CITY_CREATE";
export const CITY_DELETE = "CITY_DELETE";
export const CITY_EDIT = "CITY_EDIT";
export const CITY_UPLOAD = "CITY_UPLOAD";

// AREA
export const AREA_SEARCH = "AREA_SEARCH";
export const AREA_CREATE = "AREA_CREATE";
export const AREA_DELETE = "AREA_DELETE";
export const AREA_EDIT = "AREA_EDIT";
export const AREA_UPLOAD = "AREA_UPLOAD";

// ================== LOCATION ==================

// ================== SERVER ==================
export const SERVER_SEARCH = "SERVER_SEARCH";
export const SERVER_CREATE = "SERVER_CREATE";
export const SERVER_DELETE = "SERVER_DELETE";
export const SERVER_EDIT = "SERVER_EDIT";
export const SERVER_UPLOAD = "SERVER_UPLOAD";
// ================== SERVER ==================


// ================== PARTY GROUP ==================
export const PARTY_GROUP_SEARCH = "PARTY_GROUP_SEARCH";
export const PARTY_GROUP_CREATE = "PARTY_GROUP_CREATE";
export const PARTY_GROUP_DELETE = "PARTY_GROUP_DELETE";
export const PARTY_GROUP_EDIT = "PARTY_GROUP_EDIT";
export const PARTY_GROUP_UPLOAD = "PARTY_GROUP_UPLOAD";

export const SPECIALIZATION_SEARCH = "SPECIALIZATION_SEARCH";
export const SPECIALIZATION_CREATE = "SPECIALIZATION_CREATE";
export const SPECIALIZATION_DELETE = "SPECIALIZATION_DELETE";
export const SPECIALIZATION_EDIT = "SPECIALIZATION_EDIT";
export const SPECIALIZATION_UPLOAD = "SPECIALIZATION_UPLOAD";
export const SUB_SPECIAL_SEARCH = "SUB_SPECIAL_SEARCH";
export const SUB_SPECIAL_CREATE = "SUB_SPECIAL_CREATE";
export const SUB_SPECIAL_DELETE = "SUB_SPECIAL_DELETE";
export const SUB_SPECIAL_EDIT = "SUB_SPECIAL_EDIT";
export const SUB_SPECIAL_UPLOAD = "SUB_SPECIAL_UPLOAD";
export const INSURANCE_SEARCH = "INSURANCE_SEARCH";
export const INSURANCE_CREATE = "INSURANCE_CREATE";
export const INSURANCE_DELETE = "INSURANCE_DELETE";
export const INSURANCE_EDIT = "INSURANCE_EDIT";
export const INSURANCE_UPLOAD = "INSURANCE_UPLOAD";

//template
export const TEMPLATE_CREATE = "TEMPLATE_CREATE";
export const TEMPLATE_VIEW = "TEMPLATE_VIEW";
export const TEMPLATE_DELETE = "TEMPLATE_DELETE";
export const TEMPLATE_EDIT = "TEMPLATE_EDIT";
export const TEMPLATE_TABLE = "TEMPLATE_TABLE";

/*TCS-TDS*/
export const TCS_TAX_LIST = "TCS_TAX_LIST";
export const TCS_TAX_ADD = "TCS_TAX_ADD";
export const TCS_TAX_DELETE = "TCS_TAX_DELETE";
export const TCS_TAX_IMPORT = "TCS_TAX_IMPORT";
export const TDS_TAX_LIST = "TDS_TAX_LIST";
export const TDS_TAX_ADD = "TDS_TAX_ADD";
export const TDS_TAX_DELETE = "TDS_TAX_DELETE";
export const TDS_TAX_IMPORT = "TDS_TAX_IMPORT";
export const PARTY_LIST = "PARTY_LIST";

//STOCK TRANSFER
export const STOCK_TRANSFER_TABLE = "STOCK_TRANSFER_TABLE";
export const STOCK_TRANSFER_CREATE = "STOCK_TRANSFER_CREATE";
export const STOCK_TRANSFER_EDIT = "STOCK_TRANSFER_EDIT";
export const STOCK_TRANSFER_DECLINE = "STOCK_TRANSFER_DECLINE";
export const STOCK_TRANSFER_VIEW = "STOCK_TRANSFER_VIEW";
export const STOCK_TRANSFER_BATCH = "STOCK_TRANSFER_BATCH";
export const STOCK_OUT_GRN_ITEMS = "STOCK_OUT_GRN_ITEMS";
export const STOCK_OUT_PURCHASE_INVOICE_ITEMS = "STOCK_OUT_PURCHASE_INVOICE_ITEMS";
export const VOID_STOCK_TRANSFER = "VOID_STOCK_TRANSFER";
export const VOID_STOCK_TRANSFER_ITEM = "VOID_STOCK_TRANSFER_ITEM";

//Reports
export const OVERALL_SALES_REPORT = "OVERALL_SALES_REPORT";
export const DAILY_SALES_REPORT = "DAILY_SALES_REPORT";
export const PRODUCT_WISE_SALES_REPORT = "PRODUCT_WISE_SALES_REPORT";
export const BRANCH_WISE_SALES_REPORT = "BRANCH_WISE_SALES_REPORT";
export const DOCTOR_WISE_SALES_REPORT = "DOCTOR_WISE_SALES_REPORT";
export const PAYMENT_MODE_WISE_SALES_REPORT = "PAYMENT_MODE_WISE_SALES_REPORT";
export const PARTY_WISE_SALES_REPORT = "PARTY_WISE_SALES_REPORT";
export const PRODUCT_PURCHASE_RETURN_REPORT = "PRODUCT_PURCHASE_RETURN_REPORT";
export const B2B_SALES_SUMMARY_REPORT = "B2B_SALES_SUMMARY_REPORT";
export const STORE_PURCHASE_REPORT = "STORE_PURCHASE_REPORT";
export const REORDER_REPORT = "REORDER_REPORT";
export const PARTY_WISE_PROFIT_REPORT = "PARTY_WISE_PROFIT_REPORT";
export const DISCOUNT_ANALYSIS_REPORT = "DISCOUNT_ANALYSIS_REPORT";
export const SALES_RETURN_REPORT = "SALES_RETURN_REPORT";

export const PURCHASE_FREQ_REPORT = "PURCHASE_FREQ_REPORT";
export const PURCHASE_BEHAVIOR_REPORT = "PURCHASE_BEHAVIOR_REPORT";

export const BOUNCE_REPORT = "BOUNCE_REPORT";
export const INVENTORY_SALES_REPORT = "INVENTORY_SALES_REPORT";
export const INVENTORY_REPORT = "INVENTORY_REPORT";
export const SCHEDULED_HDRUG_REG_REPORT = "SCHEDULED_HDRUG_REG_REPORT";
export const EXPIRY_LOSS_REPORT = "EXPIRY_LOSS_REPORT";
export const SLOW_FAST_MOVING_PRODUCTS = "SLOW_FAST_MOVING_PRODUCTS";
export const PRODUCT_INFO_REPORT = "PRODUCT_INFO_REPORT";
export const CUSTOMER_PAYABLE = "CUSTOMER_PAYABLE";

export const GSTR1_REPORT = "GSTR1_REPORT";
export const GSTR2A_REPORT = "GSTR2A_REPORT";
export const GSTR_HSN_CODE_SUMMARY_REPORT = "GSTR_HSN_CODE_SUMMARY_REPORT";
export const GSTR3B_REPORT = "GSTR3B_REPORT";
export const GSTR9_REPORT = "GSTR9_REPORT";
export const GSTR9C_REPORT = "GSTR9C_REPORT";
export const GST_ITC_MISMATCH_REPORT = "GST_ITC_MISMATCH_REPORT";
export const GST_E_WAY_BILL_REPORT = "GST_E_WAY_BILL_REPORT";
export const GST_PAYMENT_SUMMARY_REPORT = "GST_PAYMENT_SUMMARY_REPORT";
export const GST_ITC_AGING_REPORT = "GST_ITC_AGING_REPORT";
export const PURCHASE_ORDER_REPORT = "PURCHASE_ORDER_REPORT";
export const ADD_BOUNCE_REPORT = "ADD_BOUNCE_REPORT";

//DASHBOARD
export const DASHBOARD_SALES = "DASHBOARD_SALES";
export const DASHBOARD_NEW_CUS_GRAPH = "DASHBOARD_ NEW_CUS_GRAPH";
export const DASHBOARD_TOP_SELLING_PRODUCTS = "DASHBOARD_TOP_SELLING_PRODUCTS";
export const DASHBOARD_LOW_STOCK = "DASHBOARD_LOW_STOCK";
export const DASHBOARD_EXPIRATION = "DASHBOARD_EXPIRATION";

//STOCK DETAILS AUDIT
export const STOCK_DETAILS_ITEMS_FETCH = "STOCK_DETAILS_ITEMS_FETCH";
export const STOCK_DETAILS_ITEM_VIEW = "STOCK_DETAILS_ITEM_VIEW";
export const STOCK_DETAILS_WAREHOUSE_LOCATION =
  "STOCK_DETAILS_WAREHOUSE_LOCATION";
export const STOCK_DETAILS_BATCH_UPDATE = "STOCK_DETAILS_BATCH_UPDATE";
export const STOCK_DETAILS_BATCH_DROP_DOWN = "STOCK_DETAILS_BATCH_DROP_DOWN";
export const STOCK_DETAILS_BATCH_VIEW = "STOCK_DETAILS_BATCH_VIEW";

export const MODULE_SETTINGS_GET_ALL = "MODULE_SETTINGS_GET_ALL";
export const MODULE_SETTINGS_UPDATE = "MODULE_SETTINGS_UPDATE";

// Custom Reports
export const CUSTOM_REPORT_VALIDATE = "CUSTOM_REPORT_VALIDATE";
export const CUSTOM_REPORT_EXECUTE = "CUSTOM_REPORT_EXECUTE";
export const CUSTOM_REPORT_SAVE = "CUSTOM_REPORT_SAVE";
export const CUSTOM_REPORT_LIST = "CUSTOM_REPORT_LIST";
export const CUSTOM_REPORT_GET = "CUSTOM_REPORT_GET";
export const CUSTOM_REPORT_UPDATE = "CUSTOM_REPORT_UPDATE";
export const CUSTOM_REPORT_DELETE = "CUSTOM_REPORT_DELETE";
export const CUSTOM_REPORT_SCHEMA = "CUSTOM_REPORT_SCHEMA";
export const CUSTOM_REPORT_EXPORT_EXCEL = "CUSTOM_REPORT_EXPORT_EXCEL";
export const CUSTOM_REPORT_EXPORT_PDF = "CUSTOM_REPORT_EXPORT_PDF";

// Custom Functions
export const CUSTOM_FUNCTION_VALIDATE = "CUSTOM_FUNCTION_VALIDATE";
export const CUSTOM_FUNCTION_SAVE = "CUSTOM_FUNCTION_SAVE";
export const CUSTOM_FUNCTION_LIST = "CUSTOM_FUNCTION_LIST";
export const CUSTOM_FUNCTION_GET = "CUSTOM_FUNCTION_GET";
export const CUSTOM_FUNCTION_UPDATE = "CUSTOM_FUNCTION_UPDATE";
export const CUSTOM_FUNCTION_DELETE = "CUSTOM_FUNCTION_DELETE";

// Function Reports
export const CUSTOM_REPORT_PARSE_PARAMETERS = "CUSTOM_REPORT_PARSE_PARAMETERS";
export const CUSTOM_REPORT_EXECUTE_FUNCTION = "CUSTOM_REPORT_EXECUTE_FUNCTION";
export const CUSTOM_REPORT_SAVE_FUNCTION_REPORT = "CUSTOM_REPORT_SAVE_FUNCTION_REPORT";
export const CUSTOM_REPORT_UPDATE_FUNCTION_REPORT = "CUSTOM_REPORT_UPDATE_FUNCTION_REPORT";
export const CUSTOM_REPORT_EXPORT_TO_CSV_URL = "CUSTOM_REPORT_EXPORT_TO_CSV_URL";

// PROMOTIONAL OFFERS
export const PROMOTIONAL_OFFER_ADD = "PROMOTIONAL_OFFER_ADD";
export const PROMOTIONAL_OFFER_UPDATE = "PROMOTIONAL_OFFER_UPDATE";
export const PROMOTIONAL_OFFER_DELETE = "PROMOTIONAL_OFFER_DELETE";
export const PROMOTIONAL_OFFER_LIST = "PROMOTIONAL_OFFER_LIST";
export const PROMOTIONAL_OFFER_VIEW = "PROMOTIONAL_OFFER_VIEW";
export const PROMOTIONAL_OFFER_ACTIVE = "PROMOTIONAL_OFFER_ACTIVE";

//APPROVAL WORK FLOW
export const ADD_APPPROVAL_WORK_FLOW= "ADD_APPPROVAL_WORK_FLOW";
export const ADD_ORIGINATORS= "ADD_ORIGINATORS";
export const GET_ALL_USERS_BY_ROLE_ID= "GET_ALL_USERS_BY_ROLE_ID";
export const GET_APPROVAL_FLOW_BY_ID = "GET_APPROVAL_FLOW_BY_ID";
export const GET_APPROVAL_FLOW_LIST = "GET_APPROVAL_FLOW_LIST";
export const UPDATE_APPROVAL_FLOW = "UPDATE_APPROVAL_FLOW";
export const UPDATE_STAGES = "UPDATE_STAGES";
export const UPDATE_DOCUMENTS = "UPDATE_DOCUMENTS";
export const GET_MAIN_MODULES="GET_MAIN_MODULES";
export const GET_SUB_MODULES="GET_SUB_MODULES";
export const GET_COLUMNS = "GET_COLUMNS";
export const ADD_DOCUMENTS = "ADD_DOCUMENTS";
export const ADD_STAGES="ADD_STAGES";
export const GET_APPROVAL_LIST="GET_APPROVAL_LIST";
export const GET_APPROVAL_ACCEPTANCE="GET_APPROVAL_ACCEPTANCE";
export const APPROVER_ACTION="APPROVER_ACTION";

//VENDOR MAPPING
export const GET_VENDOR_UOM_MAPPING="GET_VENDOR_UOM_MAPPING";
export const VENDOR_MAPPING="VENDOR_MAPPING";
export const VENDOR_TABLE="VENDOR_TABLE";
export const VENDOR_MAPPED="VENDOR_MAPPED";
export const DELETE_VENDOR_MAPPING="DELETE_VENDOR_MAPPING";

// ============================================================================
// Loyalty (v1)
// ============================================================================
export const LOYALTY_CONFIG_GET = "LOYALTY_CONFIG_GET";
export const LOYALTY_CONFIG_UPDATE = "LOYALTY_CONFIG_UPDATE";
export const LOYALTY_MEMBER_GET = "LOYALTY_MEMBER_GET";
export const LOYALTY_EXPIRY_ROWS_GET = "LOYALTY_EXPIRY_ROWS_GET";
export const LOYALTY_REDEEM_PREVIEW = "LOYALTY_REDEEM_PREVIEW";
export const LOYALTY_OTP_REQUEST = "LOYALTY_OTP_REQUEST";
export const LOYALTY_OTP_VERIFY = "LOYALTY_OTP_VERIFY";
export const LOYALTY_OTP_STATUS = "LOYALTY_OTP_STATUS";
export const LOYALTY_REDEEM_APPLY = "LOYALTY_REDEEM_APPLY";
export const LOYALTY_REDEEM_REVERSE = "LOYALTY_REDEEM_REVERSE";
export const LOYALTY_ADJUST = "LOYALTY_ADJUST";
export const LOYALTY_ENROL = "LOYALTY_ENROL";
export const LOYALTY_RUNTIME_GET = "LOYALTY_RUNTIME_GET";

// ============================================================================
// Coupons (v1)
// ============================================================================
export const COUPON_LIST = "COUPON_LIST";
export const COUPON_GET = "COUPON_GET";
export const COUPON_CREATE = "COUPON_CREATE";
export const COUPON_UPDATE = "COUPON_UPDATE";
export const COUPON_PAUSE = "COUPON_PAUSE";
export const COUPON_RESUME = "COUPON_RESUME";
export const COUPON_ARCHIVE = "COUPON_ARCHIVE";
export const COUPON_SERIES_GET = "COUPON_SERIES_GET";
export const COUPON_SERIES_CANCEL = "COUPON_SERIES_CANCEL";
export const COUPON_CODE_LOOKUP = "COUPON_CODE_LOOKUP";
export const COUPON_APPLY = "COUPON_APPLY";
export const COUPON_REVERSE = "COUPON_REVERSE";
export const COUPON_USAGE_SYNC = "COUPON_USAGE_SYNC";

// ============================================================================
// Schemes (v1)
// ============================================================================
export const SCHEME_LIST = "SCHEME_LIST";
export const SCHEME_GET = "SCHEME_GET";
export const SCHEME_CREATE = "SCHEME_CREATE";
export const SCHEME_UPDATE = "SCHEME_UPDATE";
export const SCHEME_PAUSE = "SCHEME_PAUSE";
export const SCHEME_RESUME = "SCHEME_RESUME";
export const SCHEME_ARCHIVE = "SCHEME_ARCHIVE";
export const SCHEME_REORDER = "SCHEME_REORDER";
export const SCHEME_EVALUATE = "SCHEME_EVALUATE";
export const STORE_DRUG_UPDATE = "STORE_DRUG_UPDATE";
export const FOFO_STORE_TYPES_GET = "FOFO_STORE_TYPES_GET";

// ============================================================================
// COCO bulk payment (rent / SD)
// ============================================================================
export const COCO_BULK_PAYMENT_UPLOAD = "COCO_BULK_PAYMENT_UPLOAD";
export const COCO_PAYMENT_HISTORY_GET = "COCO_PAYMENT_HISTORY_GET";

// Auto replenishment (Auto Stock / Auto PO) settings
export const AUTO_PO_STOCK_SETTINGS_GET = "AUTO_PO_STOCK_SETTINGS_GET";
export const AUTO_PO_STOCK_SETTINGS_SAVE = "AUTO_PO_STOCK_SETTINGS_SAVE";
export const AUTO_PO_STOCK_VENDORS_GET = "AUTO_PO_STOCK_VENDORS_GET";
export const AUTO_PO_STOCK_PAY_ADDRESSES_GET = "AUTO_PO_STOCK_PAY_ADDRESSES_GET";
export const AUTO_PO_STOCK_SHIP_ADDRESSES_GET = "AUTO_PO_STOCK_SHIP_ADDRESSES_GET";
